<template>
    <div class="checkout-step">
        <template v-if="billingAddress">
            <t-info-list-item>
                <template v-slot:icon>
                    <i class="fas fa-2x fa-receipt"></i>
                </template>

                <template v-slot:title>
                    {{ billingAddress.name }} <template v-if="billingAddress.cuit">- {{ billingAddress.cuit }}</template>
                </template>

                <template v-slot:subtitle>
                    {{ billingAddress.ivaCondition }} <template v-if="billingAddress.address">- {{ billingAddress.address }}</template>
                </template>

                <template v-slot:actions>
                    <a @click="onChangeAddressSelected">Cambiar</a>
                </template>
            </t-info-list-item>
        </template>
        <template v-else>
            <billing-address-create
                    :canCancel="false"
                    v-model="billingAddress"
            >
            </billing-address-create>
        </template>

        <div v-bind:class="{ 'is-active': modalActive }" class="modal">
            <div class="modal-background" v-on:click="onCloseClicked"></div>

            <div class="modal-content container">
                <div class="box is-marginless">
                    <h1 class="title">Datos para tu factura</h1>

                    <billing-address-list
                            v-model="billingAddress"
                            :canDelete="false"
                    >
                    </billing-address-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TInfoListItem from '../../components/ui/TInfoListItem';
    import BillingAddressList from "../../components/address/BillingAddressList";
    import BillingAddressCreate from "../../components/address/BillingAddressCreate";

    export default {
        data() {
            return {
                modalActive: false,
                billingAddress: null,
            }
        },

        components: {
            BillingAddressCreate,
            BillingAddressList,
            TInfoListItem,
        },

        computed: {
            customer() {
                return this.$store.getters['customer/get']();
            },

            addresses() {
                return this.customer.billingAddresses;
            }
        },

        mounted() {
            if(this.addresses && this.addresses.length > 0)
                this.billingAddress = this.addresses[0];
        },

        watch: {
            billingAddress(value) {
                this.$emit('input', value);
                this.modalActive = false;
            },
        },

        methods: {
            onAddAddressSelected() {
                this.modalActive = true;
            },

            onChangeAddressSelected() {
                this.modalActive = true;
            },

            onCloseClicked() {
                this.modalActive = false;
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "./../../assets/css/checkout.scss";
</style>